<template><section><template>
<h3>页面提示</h3>
<div class="bs-docs-section">
<div class="bs-example">
  <n3-button @click.native="showToast">点击</n3-button>
<div>
<pre v-pre=""><code v-pre="" class="language-html"><span class="hljs-tag">&lt;<span class="hljs-name">n3-button</span> <span class="hljs-attr">@click.native</span>=<span class="hljs-string">"showToast"</span>&gt;</span>点击<span class="hljs-tag">&lt;/<span class="hljs-name">n3-button</span>&gt;</span>
</code></pre>
<pre v-pre=""><code v-pre="" class="language-javascript"><span class="hljs-keyword">export</span> <span class="hljs-keyword">default</span> {
  <span class="hljs-attr">methods</span>: {
    showToast () {
      <span class="hljs-keyword">this</span>.n3Toast({
        <span class="hljs-attr">text</span>: <span class="hljs-string">'成功'</span>,
        <span class="hljs-attr">type</span>: <span class="hljs-string">'success'</span>,
        <span class="hljs-attr">placement</span>: <span class="hljs-string">'top'</span>,
        <span class="hljs-attr">closeOnClick</span> : <span class="hljs-literal">true</span>
      })
    }
  }
}
</code></pre>
<h3>参数</h3>
<table>
<thead>
<tr>
<th>参数名</th>
<th>类型</th>
<th>默认值</th>
<th>说明</th>
</tr>
</thead>
<tbody>
<tr>
<td>text</td>
<td><code v-pre="">String</code></td>
<td>-</td>
<td>文字显示</td>
</tr>
<tr>
<td>placement</td>
<td><code v-pre="">String</code></td>
<td><code v-pre="">String</code>. 如: <code v-pre="">top</code>, <code v-pre="">top-right</code>,<code v-pre="">top-left</code>, <code v-pre="">bottom</code>,<code v-pre="">bottom-left</code>, <code v-pre="">bottom-right</code>默认在页面中间</td>
<td>位置</td>
</tr>
<tr>
<td>type</td>
<td><code v-pre="">String</code>. 如: <code v-pre="">default</code>, <code v-pre="">primary</code>, <code v-pre="">success</code>, <code v-pre="">info</code>, <code v-pre="">warning</code>, <code v-pre="">danger</code></td>
<td><code v-pre="">default</code></td>
<td>颜色</td>
</tr>
<tr>
<td>duration</td>
<td><code v-pre="">Number</code></td>
<td><code v-pre="">3000</code></td>
<td><code v-pre="">0</code>为不消失</td>
</tr>
<tr>
<td>closeOnClick</td>
<td><code v-pre="">Boolean</code></td>
<td><code v-pre="">true</code></td>
<td>点击消失</td>
</tr>
</tbody>
</table>
</div>
</div></div></template>

</section></template>

<script>
export default {
  methods: {
    showToast () {
      this.n3Toast({
        text: '成功',
        type: 'success',
        placement: 'top',
        closeOnClick : true
      })
    }
  }
}
</script>


// WEBPACK FOOTER //
// n3ToastDocs.md?72211cff